import { LineiconsPython } from './icons'
import ModalBody from './modal/modal-body'
import FWImage from '@/assets/images/fw.png'

type Props = {}

const Experience = (props: Props) => {
    return (
        <ModalBody>
            <div className='flex gap-x-2'>
                <span className='flex flex-col p-2 border border-blue-500 h-fit rounded-full'>
                    <LineiconsPython width={24} height={24}/>
                </span>
                
                <div className='flex w-[90%] flex-col gap-y-2'>
                    <span className='text-blue-500 text-xs font-bold'>Mar 2023 - July 2023 (3 months)</span>
                    <h1 className='text-xl font-bold'>I Trending Goods Company Limited</h1>
                    <span className='text-gray-200 text-sm font-bold'>PoS Desktop Application (Freelance)</span>
                    <img
                        src={FWImage}
                        alt="exp logo"
                        className='rounded-lg'
                    />
                    <p className='indent-14 max-sm:text-sm'>Developed a Point-of-Sale (POS) Desktop Application using Python with PyQt for the graphical user interface and MySQL for backend data management. The system included features such as inventory tracking, sales processing, customer management, and real-time reporting. Ensured a user-friendly design, robust performance, and secure data handling to support daily retail operations.</p>
                </div>
            </div>
        </ModalBody>
    )
}

export default Experience